/* ================================================== */
/* ACCESSIBILITY
/* ================================================== */

$(document).ready(function() {
	// Set ARIA on <details> tags
	$('details').each(function(index, element){
		$(element).click(function(){
			var ariaExpanded = $(element).attr('aria-expanded');
			if (typeof ariaExpanded !== typeof undefined && ariaExpanded == 'true'){
				$(element).attr('aria-expanded', 'false');
			} else if (typeof ariaExpanded !== typeof undefined && ariaExpanded == 'false') {
				$(element).attr('aria-expanded', 'true');
			}
		});
	});
});